import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import './styles/chatProductStyles.css';
import './styles/productStyles.css';

// S'assurer que l'élément root existe
const rootElement = document.getElementById('root');
const container = document.getElementById('chat-container');

// Initialisation normale si on n'est pas dans le widget
if (rootElement && !container) {
  createRoot(rootElement).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}

// Initialisation du widget si on est dans le widget
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}